"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppNameAndDescription = exports.AppName = exports.AppInfoRoot = exports.AppIcon = exports.AppDescription = void 0;
var _mui = require("@ori-ui/mui");
const AppInfoRoot = exports.AppInfoRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  gap: theme.spacing(2)
}));
const AppIcon = exports.AppIcon = (0, _mui.styled)('img')({
  height: 60,
  width: 60
});
const AppNameAndDescription = exports.AppNameAndDescription = (0, _mui.styled)('div')({
  alignItems: 'flex-start',
  alignSelf: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: 2
});
const AppName = exports.AppName = (0, _mui.styled)(_mui.Typography)({
  display: '-webkit-box',
  fontSize: '1.3rem',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1
});
const AppDescription = exports.AppDescription = (0, _mui.styled)(_mui.Typography)({
  display: '-webkit-box',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2
});
